import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

//Project
import ProjectsReducer from "./projects/reducer";

// DigitalSignature
import CatalogReducer from "./catalogs/reducer";

// Users
import UsersReducer from "./users/reducer";
// Roles
import RolesReducer from "./roles/reducer";
// Companies
import CompaniesReducer from "./companies/reducer";
// Invoicing
import InvoicingReducer from "./invoicing/reducer";
// Products
import ProductsReducer from "./products/reducer";
// Customers
import CustomersReducer from "./customers/reducer";
// Waybills
import WaybillsReducer from "./waybills/reducer";
// Assignments
import AssignmentsReducer from "./assignments/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Projects: ProjectsReducer,
    Catalogs: CatalogReducer,
    Users: UsersReducer,
    Roles: RolesReducer,
    Companies: CompaniesReducer,
    Invoicing: InvoicingReducer,
    Products: ProductsReducer,
    Customers: CustomersReducer,
    Waybills: WaybillsReducer,
    Assignment: AssignmentsReducer,
    });

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
